export default {
	"pages": {
		"root": {
			"id": "root",
			"pageUrl": "root",
			"name": "root",
			"children": [
				"649820fc477c3a0019b3f1db",
				"649820fc477c3a0019b3f1de",
				"649822b472a6d30018247883"
			]
		},
		"649820fc477c3a0019b3f1db": {
			"id": "649820fc477c3a0019b3f1db",
			"name": "404",
			"pageUrl": "404"
		},
		"649820fc477c3a0019b3f1de": {
			"id": "649820fc477c3a0019b3f1de",
			"name": "index",
			"pageUrl": "index"
		},
		"649822b472a6d30018247883": {
			"id": "649822b472a6d30018247883",
			"pageUrl": "rank",
			"name": "Rank"
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {},
		"seo": {}
	}
}